import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Children } from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import Header from './Header';
import getDataset from '../utils/dom/getDataset';
import Wrapper from './Wrapper';
import Sticky from '../Sticky';
import { tabsClass } from './styles';
import { isEmpty, isObject } from '../utils/is';
import { isRTL } from '../config';
import Panel from './Panel';
import Link from './Link';
var DefaultValue = {
  defaultCollapsed: false,
  lazy: true,
  hideSplit: false
};

var Tabs =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Tabs, _PureComponent);

  var _super = _createSuper2(Tabs);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _super.call(this, props);
    _this.container = void 0;
    _this.sticky = void 0;
    _this.state = {
      active: props.defaultActive || 0,
      collapsed: props.defaultCollapsed
    };
    _this.getAlign = _this.getAlign.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleCollapse = _this.handleCollapse.bind(_assertThisInitialized(_this));
    _this.renderContent = _this.renderContent.bind(_assertThisInitialized(_this));
    _this.bindContainer = _this.bindContainer.bind(_assertThisInitialized(_this));
    _this.setStickyStatus = _this.setStickyStatus.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Tabs, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
          sticky = _this$props.sticky,
          switchToTop = _this$props.switchToTop,
          active = _this$props.active;

      if ((prevProps.active !== active || prevState.active !== this.state.active) && this.container && !isEmpty(sticky) && switchToTop && this.sticky) {
        // jump to active panel
        this.container.scrollIntoView(true);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.container = null;
    }
  }, {
    key: "getAlign",
    value: function getAlign() {
      var _this$props2 = this.props,
          shape = _this$props2.shape,
          collapsible = _this$props2.collapsible,
          align = _this$props2.align;
      var isVertical = align && align.indexOf('vertical') > -1;

      if (shape === 'button' && isVertical) {
        console.warn("align vertical-* can't supported when shape is button");
        return {
          align: 'left',
          isVertical: false
        };
      }

      if (collapsible && isVertical) {
        console.warn("align vertical-* can't supported when collapsible is true");
        return {
          align: 'left',
          isVertical: false
        };
      }

      return {
        align: align,
        isVertical: isVertical
      };
    }
  }, {
    key: "getActive",
    value: function getActive() {
      if ('active' in this.props) return this.props.active;
      return this.state.active;
    }
  }, {
    key: "setStickyStatus",
    value: function setStickyStatus(flag) {
      var _this$props3 = this.props,
          sticky = _this$props3.sticky,
          switchToTop = _this$props3.switchToTop;
      if (!sticky || !switchToTop) return;
      this.sticky = flag;
    }
  }, {
    key: "bindContainer",
    value: function bindContainer(node) {
      this.container = node;
    }
  }, {
    key: "handleChange",
    value: function handleChange(active) {
      var onChange = this.props.onChange;
      if (onChange) onChange(active);
      this.setState({
        active: active
      });
    }
  }, {
    key: "handleCollapse",
    value: function handleCollapse(collapsed) {
      this.setState({
        collapsed: collapsed
      });
    }
  }, {
    key: "renderHeader",
    value: function renderHeader(_ref) {
      var _this2 = this;

      var align = _ref.align,
          isVertical = _ref.isVertical;
      var _this$props4 = this.props,
          children = _this$props4.children,
          color = _this$props4.color,
          shape = _this$props4.shape,
          tabBarStyle = _this$props4.tabBarStyle,
          inactiveBackground = _this$props4.inactiveBackground,
          collapsible = _this$props4.collapsible,
          tabBarExtraContent = _this$props4.tabBarExtraContent,
          sticky = _this$props4.sticky,
          hideSplit = _this$props4.hideSplit;
      var active = this.getActive();
      var tabs = [];
      var border = this.props.border;
      Children.toArray(children).forEach(function (child, i, arr) {
        if (!child || !child.type) return;
        var tab = null;

        if (child.type.isTabPanel) {
          // eslint-disable-next-line
          tab = child.props.tab;
        } else if (child.type.isTabLink) {
          tab = child;
        } else return;

        var _child$props = child.props,
            _child$props$id = _child$props.id,
            id = _child$props$id === void 0 ? i : _child$props$id,
            background = _child$props.background;
        var childBorder = child.props.border; // eslint-disable-next-line

        if (active === id) {
          if (childBorder) border = childBorder;else childBorder = border;
        }

        tabs.push(_objectSpread2({
          id: id,
          isActive: active === id,
          tab: tab,
          isVertical: isVertical,
          align: align,
          background: background || (active === id ? _this2.props.background : inactiveBackground),
          border: childBorder,
          color: child.props.color || (active === id ? color : undefined),
          disabled: child.props.disabled,
          shape: shape,
          last: arr.length - 1 === i
        }, getDataset(child.props)));
      });
      var header =
      /*#__PURE__*/
      React.createElement(Header, {
        isVertical: isVertical,
        border: border,
        collapsed: this.state.collapsed,
        onCollapse: collapsible ? this.handleCollapse : undefined,
        shape: shape,
        onChange: this.handleChange,
        tabs: tabs,
        tabBarExtraContent: tabBarExtraContent,
        tabBarStyle: tabBarStyle,
        hideSplit: hideSplit
      });

      if (!isEmpty(sticky) && !isVertical) {
        var stickyClassName = tabsClass('sticky');
        var stickyProps = {
          top: 0,
          className: stickyClassName
        };

        if (typeof sticky === 'number') {
          stickyProps.top = sticky;
        }

        if (isObject(sticky)) {
          stickyProps = _objectSpread2(_objectSpread2({}, sticky), {}, {
            className: classnames(stickyClassName, sticky.className)
          });
        }

        return (
          /*#__PURE__*/
          React.createElement(Sticky, Object.assign({
            onChange: this.setStickyStatus
          }, stickyProps), header)
        );
      }

      return header;
    }
  }, {
    key: "renderContent",
    value: function renderContent(child, i) {
      if (!(child && child.type && child.type.isTabPanel)) return null;
      var _this$props5 = this.props,
          collapsible = _this$props5.collapsible,
          lazy = _this$props5.lazy;

      var _child$props2 = child.props,
          _child$props2$id = _child$props2.id,
          id = _child$props2$id === void 0 ? i : _child$props2$id,
          other = _objectWithoutProperties(_child$props2, ["id"]);

      return (
        /*#__PURE__*/
        React.createElement(Wrapper, Object.assign({}, other, {
          lazy: lazy,
          collapsed: this.state.collapsed,
          collapsible: collapsible,
          id: id,
          key: id,
          active: this.getActive()
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          children = _this$props6.children,
          shape = _this$props6.shape,
          style = _this$props6.style,
          autoFill = _this$props6.autoFill;
      var position = this.getAlign();
      var align = position.align,
          isVertical = position.isVertical;
      var className = classnames(tabsClass('_', align && "align-".concat(align), isVertical && 'vertical', shape, autoFill && 'auto-fill', isRTL() && 'rtl'), this.props.className);
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          style: style,
          ref: this.bindContainer
        }, align !== 'vertical-right' && align !== 'bottom' && this.renderHeader(position), Children.toArray(children).map(this.renderContent), (align === 'vertical-right' || align === 'bottom') && this.renderHeader(position))
      );
    }
  }]);

  return Tabs;
}(PureComponent);

Tabs.defaultProps = DefaultValue;
Tabs.Panel = Panel;
Tabs.Link = Link;
Tabs.displayName = void 0;
export default Tabs;